import { RoundandclinicSearchComponent } from './../roundandclinic-search/roundandclinic-search.component';
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { LocalStorageService } from 'ngx-webstorage';
import { formatDate } from '@angular/common';
import { DataBankService } from 'src/app/services/DataBankService';
import { DatabankModel } from 'src/app/models/DataBankModel';
import { PopuppatientsearchComponent } from '../popuppatientsearch/popuppatientsearch.component';
import { URLsConfig } from 'src/app/URLsConfig';
import { ThemePalette } from '@angular/material/core';
import { RoundAndClinicService } from 'src/app/services/RoundAndClinicService';
import { RoundAndClinicModel } from 'src/app/models/RoundAndClinicModel';
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { DoctorsService } from 'src/app/services/DoctorsService';
import { ViewEncapsulation } from '@angular/compiler';
export interface Task {
  name: string;
  completed: boolean;
  color: ThemePalette;
  subtasks?: Task[];
}

@Component({
  selector: 'app-round-and-clinic',
  templateUrl: './round-and-clinic.component.html',
  styleUrls: ['./round-and-clinic.component.css'],
  // encapsulation: ViewEncapsulation.None
})
export class RoundAndClinicComponent implements OnInit {
  patientcode = '';
  note = '';
  patientFName = '';
  notetype = '';
  extra = '';
  Laboratory = '';
  toxicity = '';
  ClinicReferral = '';
  Response = '';
  DrugInteractions = '';
  Hypersensitive = '';
  PatientEducation = '';
  date = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  userid = '';
  compcode = '';
  usergroup = '';
  extra_Check = true;
  docDepartment = '';
  task: Task = {
    name: 'Indeterminate',
    completed: false,
    color: 'primary',
    subtasks: [
      {name: 'Primary', completed: false, color: 'primary'},
      {name: 'Accent', completed: false, color: 'accent'},
      {name: 'Warn', completed: false, color: 'warn'},
    ],
  };

  @Output() submitClicked = new EventEmitter<any>();

  constructor(
    public storage: LocalStorageService,
    public dataBankService: DataBankService,
    public patientsSelectedData: DatabankModel,
    public roundsandclinicservice: RoundAndClinicService,
    public DoctorsService : DoctorsService,
    public Roundandclinics: RoundAndClinicModel,
    public RoundSelectedData: RoundAndClinicModel,
    public dialogref: MatDialog,
    public urlsconfig: URLsConfig
  ) {}

  ngOnInit(): void {
    this.patientcode = this.storage.retrieve('stgPatientCode');
    this.patientFName = this.storage.retrieve('stgPatientName');
    this.RertivePatient();
    this.retriveDoctors();

  }

  retriveDoctors(){
          this.DoctorsService.getdoctors(this.storage.retrieve('stgEmpId'),'1').subscribe((data :DoctorsModel)=>{
      this.docDepartment = data.docDepartment;
     })
  }
  mesgSave() {
    Swal({
      title: 'Your work has been saved',
      type: 'success',
      showConfirmButton: false,
      timer: 1500,
    });
  }
  mesgwarning() {
    Swal({
      title: 'Enter patient Number',
      type: 'warning',
      showConfirmButton: false,
      timer: 1500,
    });
  }
        MesgAddWarrning(){

          Swal({
            title: 'Check Department',
            text:'Adding to  this medical record  is not allowed for your Department',
            type: 'warning',
            showCancelButton: false,
            confirmButtonText: 'OK',
            //cancelButtonText: 'No, keep it',
          })
          ;

        }
  RertivePatient() {
    this.dataBankService
      .getPatient(this.patientcode, this.storage.retrieve('stgcompCode'))
      .subscribe((data: DatabankModel) => {
        this.patientFName = data.patientFName;
      });
    this.storage.store('stgPatientCode', this.patientcode);
  }

  OpenEmployeeDialog() {
    const dialogRef = this.dialogref.open(PopuppatientsearchComponent, {
      data: {
        dataKey: this.patientsSelectedData,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {});
    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe((result) => {
        this.patientcode = result.patientCode;
        this.RertivePatient();

        dialogSubmitSubscription.unsubscribe();
      });
  }
    submitLaboratory() {
    if (this.patientcode === ''|| this.patientcode === null ) {return this.mesgwarning();} else {
      if (this.docDepartment !== 'Pharmaceutical'){return this.MesgAddWarrning();}
    this.Roundandclinics.patientcode = this.patientcode;
    this.Roundandclinics.notetype = 'Laboratory';
    this.Roundandclinics.note = this.Laboratory;
    this.Roundandclinics.date = this.date;
    this.Roundandclinics.extra = this.storage.retrieve('stgusername') ;
    this.Roundandclinics.userid = this.storage.retrieve('stguserid');
    this.Roundandclinics.compcode = this.storage.retrieve('stgcompcode');
    this.roundsandclinicservice.Addroundandclinic(this.Roundandclinics).subscribe(data =>{
    this.mesgSave();
    this.newData();
    });
    }
    

  }
   submittoxicity() {
    if (!this.patientcode) {return this.mesgwarning();} else {
            if (this.docDepartment !== 'Pharmaceutical'){return this.MesgAddWarrning();}
    this.Roundandclinics.patientcode = this.patientcode;
    this.Roundandclinics.notetype = 'Toxicity';
    this.Roundandclinics.note = this.toxicity;
    this.Roundandclinics.date = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.Roundandclinics.extra = this.storage.retrieve('stgusername') ;
    this.Roundandclinics.userid = this.storage.retrieve('stguserid');
    this.Roundandclinics.compcode = this.storage.retrieve('stgcompcode');
    this.roundsandclinicservice.Addroundandclinic(this.Roundandclinics).subscribe(data =>{
    this.mesgSave();
    this.newData();
    });
  }
  }

  submitClinicReferral() {
    if (!this.patientcode ) {return this.mesgwarning();} else {
            if (this.docDepartment !== 'Pharmaceutical'){return this.MesgAddWarrning();}
    this.Roundandclinics.patientcode = this.patientcode;
    this.Roundandclinics.notetype = 'Clinic Referral';
    this.Roundandclinics.note = this.ClinicReferral;
    this.Roundandclinics.date = formatDate(new Date(), 'yyyy-MM-dd', 'en');
        this.Roundandclinics.extra = this.storage.retrieve('stgusername') ;

    this.Roundandclinics.userid = this.storage.retrieve('stguserid');
    this.Roundandclinics.compcode = this.storage.retrieve('stgcompcode');
    this.roundsandclinicservice.Addroundandclinic(this.Roundandclinics).subscribe(data =>{
    this.mesgSave();
    this.newData();
    });}
  }

    submitResponse() {
      if (!this.patientcode) {return this.mesgwarning();} else {
              if (this.docDepartment !== 'Pharmaceutical'){return this.MesgAddWarrning();}
    this.Roundandclinics.patientcode = this.patientcode;
    this.Roundandclinics.notetype = 'Response';
    this.Roundandclinics.note = this.Response;
    this.Roundandclinics.date = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.Roundandclinics.extra = this.storage.retrieve('stgusername') ;
    this.Roundandclinics.userid = this.storage.retrieve('stguserid');
    this.Roundandclinics.compcode = this.storage.retrieve('stgcompcode');
    this.roundsandclinicservice.Addroundandclinic(this.Roundandclinics).subscribe(data =>{
    this.mesgSave();
    this.newData();
    });}
  }

  submitDrugInteractions() {
    if (!this.patientcode) {return this.mesgwarning();} else {
            if (this.docDepartment !== 'Pharmaceutical'){return this.MesgAddWarrning();}
    this.Roundandclinics.patientcode = this.patientcode;
    this.Roundandclinics.notetype = 'Drug Interactions';
    this.Roundandclinics.note = this.DrugInteractions;
    this.Roundandclinics.date = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.Roundandclinics.extra = this.storage.retrieve('stgusername') ;

    this.Roundandclinics.userid = this.storage.retrieve('stguserid');
    this.Roundandclinics.compcode = this.storage.retrieve('stgcompcode');
    this.roundsandclinicservice.Addroundandclinic(this.Roundandclinics).subscribe(data =>{
    this.mesgSave();
    this.newData();
    });}
  }

    submitHypersensitive() {

   if (!this.patientcode) {return this.mesgwarning();} else {
          if (this.docDepartment !== 'Pharmaceutical'){return this.MesgAddWarrning();}
    this.Roundandclinics.patientcode = this.patientcode;
    this.Roundandclinics.notetype = 'Hypersensitivity';
    this.Roundandclinics.note = this.Hypersensitive;
    this.Roundandclinics.date = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.Roundandclinics.extra = this.storage.retrieve('stgusername') ;
    this.Roundandclinics.userid = this.storage.retrieve('stguserid');
    this.Roundandclinics.compcode = this.storage.retrieve('stgcompcode');
    this.roundsandclinicservice.Addroundandclinic(this.Roundandclinics).subscribe(data =>{
    this.mesgSave();
    this.newData();
    });
  }
  }

      submitPatientEducation() {
        console.log (this.storage.retrieve('stgdocDepartment'))
        if (!this.patientcode) {return this.mesgwarning();} else {
                if (this.docDepartment !== 'Pharmaceutical'){return this.MesgAddWarrning();}
    this.Roundandclinics.patientcode = this.patientcode;
    this.Roundandclinics.notetype = 'PatientEducation';
    this.Roundandclinics.note = this.PatientEducation;
    this.Roundandclinics.date = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.Roundandclinics.extra = this.storage.retrieve('stgusername') ;

    this.Roundandclinics.userid = this.storage.retrieve('stguserid');
    this.Roundandclinics.compcode = this.storage.retrieve('stgcompcode');
    this.roundsandclinicservice.Addroundandclinic(this.Roundandclinics).subscribe(data =>{
    this.mesgSave();
    this.newData();
    });
  }
  }


  newData() {
    this.notetype = '';
    this.Laboratory = '';
    this.toxicity = '';
    this.ClinicReferral = '';
    this.Response = '';
    this.DrugInteractions = '';
    this.Hypersensitive = '';
    this.PatientEducation = '';
    this.extra = '';
    // this.extra_Check= false ;
    this.date = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.userid = '';
    this.compcode = '';
  }

  RoundAndClinicOpen(): void {
  const dialogRef = this.dialogref.open(RoundandclinicSearchComponent, {
    data: {
      dataKey: this.RoundSelectedData,
    },
  });

  dialogRef.afterClosed().subscribe((data) => {
    if (!data) return;

    // Assign common fields first
    this.patientcode = data.patientcode;
    this.notetype = data.notetype;
    this.date = data.date;
    this.extra = data.extra;
    this.userid = data.userid;
    this.compcode = data.compcode;

    // Assign note based on type
    switch (this.notetype) {
      case 'Laboratory':
        this.Laboratory = data.note;
        break;

      case 'Toxicity':
        this.toxicity = data.note;
        break;

      case 'Clinic Referral':
        this.ClinicReferral = data.note;
        break;
      case 'Nutrition':
        this.ClinicReferral = data.note;
        break;
      case 'Response':
        this.Response = data.note;
        break;

      case 'Drug Interactions':
        this.DrugInteractions = data.note;
        break;

      case 'Hypersensitivity':
        this.Hypersensitive = data.note;
        break;

      case 'PatientEducation':
        this.PatientEducation = data.note;
        break;
    }
  });
}


}
